import React from "react"
import PropTypes from "prop-types"
import CustomModal from "./CustomModal"
import { ModalBody, ModalFooter } from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"

const WarningModalHTML = ({ modal, onToggle, message, t }) => {
  message = message || t("SelectRowWarning")
  return (
    <CustomModal
      modal={modal}
      classBackground={"bg-warning"}
      onToggle={onToggle}
      size={"md"}
      title={t("Warning")}
    >
      <ModalBody>
        <div dangerouslySetInnerHTML={{ __html: message }}></div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <button type="button" onClick={onToggle} className="btn btn-secondary button-width">
          OK
        </button>
      </ModalFooter>
    </CustomModal>
  )
}

WarningModalHTML.propTypes = {
  message: PropTypes.string,
}
WarningModalHTML.defaultProps = {
  // message: "Please select a row",
}

export default withTranslation(["message"])(WarningModalHTML)
